import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadPatientByTrialInstitution: IPatientLoadByTrialInstitutionActionCreator = (trialId, institutionId) => {
        return {
            type: ACTION_PATIENT_LOAD_BY_TRIALINSTITUTION,
            trialId,
            institutionId
        }
    },
    LoadSuccess: IPatientLoadSuccessActionCreator = (data, databaseStatus, statusMessage, responseStatus) => {
        return {
            type: ACTION_PATIENT_LOAD_SUCCESS,
            data,
            databaseStatus,
            statusMessage,
            responseStatus
        }
    },
    LoadFailure: IPatientLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PATIENT_LOAD_FAILURE,
            responseStatus
        }
    },
    Clear: IPatientClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PATIENT_CLEAR,
            propertiesToClear
        }
    };

export const
    ACTION_PATIENT_LOAD_BY_TRIALINSTITUTION = "ACTION_PATIENT_LOAD_BY_TRIALINSTITUTION",
    ACTION_PATIENT_LOAD_SUCCESS = "ACTION_PATIENT_LOAD_SUCCESS",
    ACTION_PATIENT_LOAD_FAILURE = "ACTION_PATIENT_LOAD_FAILURE",

    ACTION_PATIENT_SAVE = "ACTION_PATIENT_SAVE",
    ACTION_PATIENT_SAVE_SUCCESS = "ACTION_PATIENT_SAVE_SUCCESS",
    ACTION_PATIENT_SAVE_FAILURE = "ACTION_PATIENT_SAVE_FAILURE",

    ACTION_PATIENT_CREATE = "ACTION_PATIENT_CREATE",
    ACTION_PATIENT_CREATE_SUCCESS = "ACTION_PATIENT_CREATE_SUCCESS",
    ACTION_PATIENT_CREATE_FAILURE = "ACTION_PATIENT_CREATE_FAILURE",

    ACTION_PATIENT_CLEAR = "ACTION_PATIENT_CLEAR",
    ACTION_PATIENT_FILTER = "ACTION_PATIENT_FILTER";

export interface IPatientLoadByTrialInstitutionAction {
    type: "ACTION_PATIENT_LOAD_BY_TRIALINSTITUTION";
    trialId: number;
    institutionId: number;
}

export interface IPatientLoadByTrialInstitutionActionCreator {
    (trialId: number, institutionId: number): IPatientLoadByTrialInstitutionAction;
}

export interface IPatientLoadSuccessAction {
    type: "ACTION_PATIENT_LOAD_SUCCESS";
    data: Dtos.Patient | Dtos.Patient[];
    databaseStatus: Dtos.DatabaseStatus;
    statusMessage: string;
    responseStatus: Dtos.ResponseStatus;
}

export interface IPatientLoadSuccessActionCreator {
    (
        data: Dtos.Patient | Dtos.Patient[],
        databaseStatus: Dtos.DatabaseStatus,
        statusMessage: string,
        responseStatus: Dtos.ResponseStatus
    ): IPatientLoadSuccessAction;
}

export interface IPatientLoadFailureAction {
    type: "ACTION_PATIENT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPatientLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPatientLoadFailureAction;
}

export interface IPatientClearAction {
    type: "ACTION_PATIENT_CLEAR";
    propertiesToClear?: string[];
}

export interface IPatientClearActionCreator {
    (propertiesToClear?: string[]): IPatientClearAction;
}

export type PatientAction =
    IPatientLoadByTrialInstitutionAction |
    IPatientLoadFailureAction |
    IPatientLoadSuccessAction |
    IPatientClearAction;
